var galleryFeed = new Instafeed({
  get: "user",
  userId: '1784128893',
  accessToken: '1784128893.1677ed0.f85ff7551f844f4a928e9195208c0ab9',
  
  resolution: "standard_resolution",
  useHttp: "true",
  limit: 5,
  template: '<div class="instagram__item"><a href="{{link}}"><img src="{{image}}" class="img-responsive"></div></a></div>',
  target: "instafeed",
  after: function() {
    // disable button if no more results to load
    if (!this.hasNext()) {
      btnInstafeedLoad.setAttribute('disabled', 'disabled');
    }
  },
});
galleryFeed.run();

var btnInstafeedLoad = document.getElementById("btn-instafeed-load");
btnInstafeedLoad.addEventListener("click", function() {
  galleryFeed.next()
});
